import * as yup from 'yup';

import {
  ERROR_MESSAGE_REQUIRED_ZIP_CODE,
  emailValidationSchema,
  phoneNumberValidationSchema,
  zipCodeValidationSchema,
} from 'src/constants/validation';
import { WEBSITE_REG_EXP } from 'src/constants/validationWebsite';

import { VerifyAutomaticModalFormAddressFields, VerifyAutomaticModalFormFields } from '../types';

export const VerifyAutomaticModalFormValidationSchema = yup.object({
  [VerifyAutomaticModalFormFields.legalBusinessName]: yup
    .string()
    .nullable()
    .required('Required organization name'),
  [VerifyAutomaticModalFormFields.FEIN]: yup
    .string()
    .nullable()
    .min(9, 'Must be 9 characters')
    .required('Required FEIN'),
  [VerifyAutomaticModalFormFields.contactPhone]: phoneNumberValidationSchema.required(
    'Required contact phone number',
  ),
  [VerifyAutomaticModalFormFields.websiteURL]: yup
    .string()
    .nullable()
    .matches(WEBSITE_REG_EXP, 'Must be a valid URL')
    .required('Required website URL'),

  [VerifyAutomaticModalFormFields.firstName]: yup
    .string()
    .nullable()
    .required("Required admin's first name"),
  [VerifyAutomaticModalFormFields.lastName]: yup
    .string()
    .nullable()
    .required("Required admin's first name"),

  [VerifyAutomaticModalFormFields.phoneNumber]: phoneNumberValidationSchema.required(
    "Required admin's phone number",
  ),
  [VerifyAutomaticModalFormFields.email]: emailValidationSchema.required("Required admin's email"),
  [VerifyAutomaticModalFormFields.address]: yup.object({
    [VerifyAutomaticModalFormAddressFields.street]: yup.string().required('Required street'),
    [VerifyAutomaticModalFormAddressFields.city]: yup.string().required('Required city'),
    [VerifyAutomaticModalFormAddressFields.county]: yup.string().required('Required county'),
    [VerifyAutomaticModalFormAddressFields.state]: yup.string().required('Required state'),
    [VerifyAutomaticModalFormAddressFields.zipCode]: zipCodeValidationSchema.required(
      ERROR_MESSAGE_REQUIRED_ZIP_CODE,
    ),
  }),
});
